export enum EDruhCp {
    AKCIE = 'AKCIE',
    DLUHOPIS = 'DLUHOPIS',
    PODILLIST = 'PODILLIST',
    INVCERT = 'INVCERT',
    WARRANT = 'WARRANT',
    NASTROJKOLINV = 'NASTROJKOLINV',
    JINYINVNASTROJ = 'JINYINVNASTROJ',
    PREDNOSTNIPRAVO = 'PREDNOSTNIPRAVO',
    PRAVOUPSANI = 'PRAVOUPSANI',
    ZATIMNILISTY = 'ZATIMNILISTY',
    OSTATNI = 'OSTATNI'
}

// AKCIE - akcie
// DLUHOPIS - dluhopis
// PODILLIST - podílový list
// INVCERT - investiční certifikát
// WARRANT - warrant
// NASTROJKOLINV - nástroj kolektivního investování
// JINYINVNASTROJ - jiný investiční nástroj
// PREDNOSTNIPRAVO – přednostní právo
// PRAVOUPSANI – právo upsání
// ZATIMNILISTY – zatímní listy
// OSTATNÍ – ostatní
